import Vue from 'vue'
import Router from 'vue-router'
import http from '@/utils/request'
import { isURL } from '@/utils/validate'

Vue.use(Router)

// 页面路由(独立页面)
export const pageRoutes = [
  {
    path: '/404',
    component: () => import('@/views/pages/404'),
    name: '404',
    meta: { title: '404未找到' },
    beforeEnter (to, from, next) {
      console.log('beforeEnter',from)
      // 拦截处理特殊业务场景
      // 如果, 重定向路由包含__双下划线, 为临时添加路由
      if (/__.*/.test(to.redirectedFrom)) {
        return next(to.redirectedFrom.replace(/__.*/, ''))
      }
      next()
    },
  },
  {
    path: '/login',
    component: () => import('@/views/pages/login'),
    name: 'login',
    meta: { title: '登录' },
  }
]

// 模块路由(基于主入口布局页面)
export const moduleRoutes = {
  path: '/',
  component: () => import('@/views/main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口布局' },
  children: [
    {
      path: '/home',
      component: () => import('@/views/modules/home'),
      name: 'home',
      meta: { title: '首页', isTab: false },
    },
    {
      path: '/dict/children',
      component: () => import('@/views/modules/sys/dict'),
      name: 'dict-children', meta: { title: '字典内容', isTab: false },
    },
    {
      path: '/trade/agreement/save',
      component: () => import('@/views/modules/trade/agreement/save'),
      name: 'trade-agreement-save', meta: { title: '合同维护', isTab: false },
    },
    {
      path: '/trade/agreement/plan/save',
      component: () => import('@/views/modules/trade/agreement/plan/save'),
      name: 'trade-agreement-plan-save', meta: { title: '发货计划', isTab: false },
    },
    {
      path: '/trade/purchase/create',
      component: () => import('@/views/modules/trade/purchase/create'),
      name: 'trade-purchase-create', meta: { title: '创建采购合同', isTab: false },
    },
    {
      path: '/trade/purchase/copy',
      component: () => import('@/views/modules/trade/purchase/copy'),
      name: 'trade-purchase-copy', meta: { title: '复制采购合同', isTab: false },
    },
    // {
    //   // 旧版本
    //   path: '/trade/factory/make/save',
    //   component: () => import('@/views/modules/trade/factory-make/save'),
    //   name: 'factory-make-save', meta: { title: '创建工厂加工单', isTab: false },
    // },
    // {
    //   // 新版本生产订单修改
    //   path: '/erp/make/add',
    //   component: () => import('@/views/modules/erp/make/save'),
    //   name: 'erp-make-save', meta: { title: '创建生产订单', isTab: false },
    // },
    // {
    //   // 新版本生产订单修改
    //   path: '/erp/make/edit',
    //   component: () => import('@/views/modules/erp/make/save'),
    //   name: 'erp-make-edit', meta: { title: '修改生产订单', isTab: false },
    // },
    {
      path: '/trade/factory/store',
      component: () => import('@/views/modules/trade/factory/store'),
      name: 'factory-store', meta: { title: '工厂库存', isTab: false },
    },
    {
      // TODO:待删除
      path: '/trade/box-form/save',
      component: () => import('@/views/modules/box-form/save'),
      name: 'box-form-save', meta: { title: '上传装箱单', isTab: false },
    },
    {
      path: '/erp/box/save',
      component: () => import('@/views/modules/erp/box/save'),
      name: 'erp-box-save', meta: { title: '保存装箱单', isTab: false },
    },
    {
      path: '/erp/box/inner/save',
      component: () => import('@/views/modules/erp/box/save'),
      name: 'erp-box-inner-save', meta: { title: '开票申请', isTab: false },
    },
    {
      path: '/trade/store/log',
      component: () => import('@/views/modules/store/store-log/index'),
      name: 'store-log-index', meta: { title: '出入库记录', isTab: false },
    },
    {
      path: '/receipt/save',
      component: () => import('@/views/modules/receipt/save'),
      name: 'receipt-save', meta: { title: '销售开票', isTab: false },
    },
    {
      path: '/receipt/detail',
      component: () => import('@/views/modules/receipt/detail'),
      name: 'receipt-detail', meta: { title: '开票详情', isTab: false },
    },
    {
      path: '/purchase/save',
      component: () => import('@/views/modules/purchase/save'),
      name: 'purchase-save', meta: { title: '采购单', isTab: false },
    },
    // {
    //   path: '/erp/receipt/:type',
    //   component: () => import('@/views/modules/erp/receipt/index'),
    //   name: 'erp-receipt-index', meta: { title: '成品开票记录', isTab: false },
    //   beforeEnter: (to, from, next) => {
    //     if (to.query.type == 'product') {
    //       to.meta.title = '成品开票记录'
    //     } else if (to.query.type == 'material'){
    //       to.meta.title = '物料开票记录'
    //     }
    //     next()
    //   }
    // },
    {
      path: '/store/material/change',
      component: () => import('@/views/modules/store/material/change'),
      name: 'store-material-change', meta: { title: '原料入库', isTab: false },
      beforeEnter: (to, from, next) => {
        if (to.query.type == 1) {
          to.meta.title = '原料入库'
        } else {
          to.meta.title = '原料出库'
        }
        console.log('to.meta.title', to.meta.title)
        next()
      }
    },
    {
      path: '/store-manager/save',
      component: () => import('@/views/modules/StoreManager/save'),
      name: 'store-manager-save', meta: { title: '', isTab: false },
      beforeEnter: (to, from, next) => {
        let title = ''
        if (to.query.productType == 1) {
          title = '成品'
        } else if (to.query.productType == 2) {
          title = '原料'
        }
        if (to.query.type == 1) {
          title += '入库'
        } else {
          title += '出库'
        }
        to.meta.title = title
        next()
      }
    },
    {
      path: '/store/material/settle',
      component: () => import('@/views/modules/StoreManager/raw/settle'),
      name: 'store-material-settle', meta: { title: '用料结算', isTab: false },
    },{
      path: '/pay/sell/save',
      component: () => import('@/views/modules/erp/pay/sell/save'),
      name: 'pay-sell/save', meta: { title: '用料结算', isTab: false },
    },
    {
      path: '/erp/receipt/:type',
      component: () => import('@/views/modules/erp/pay/index'),
      name: 'erp-receipt', meta: { title: '进项发票管理', isTab: false },
    },
    {
      path: '/erp/receipt/manager/:type',
      component: () => import('@/views/modules/erp/receipt/manager/index.vue'),
      name: 'erp-receipt-manager', meta: { title: '进项发票管理', isTab: false },
    },
  ],
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: pageRoutes.concat(moduleRoutes),
})

router.beforeEach((to, from, next) => {
  // 添加动态(菜单)路由
  // 已添加或者当前路由为页面路由, 可直接访问
  if (
    window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] ||
    fnCurrentRouteIsPageRoute(to, pageRoutes)
  ) {
    return next()
  }
  // 获取菜单列表, 添加并全局变量保存
  http
    .get('/sys/menu/nav')
    .then(({ data: res }) => {
      if (res.code !== 0) {
        Vue.prototype.$message.error(res.msg)
        return next({ name: 'login' })
      }
      window.SITE_CONFIG['menuList'] = res.data
      fnAddDynamicMenuRoutes(window.SITE_CONFIG['menuList'])
      next({ ...to, replace: true })
    })
    .catch(() => {
      console.log('unlogin')
      next({ name: 'login' })
    })
})

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
function fnCurrentRouteIsPageRoute (route, pageRoutes = []) {
  var temp = []
  for (var i = 0; i < pageRoutes.length; i++) {
    if (route.path === pageRoutes[i].path) {
      return true
    }
    if (pageRoutes[i].children && pageRoutes[i].children.length >= 1) {
      temp = temp.concat(pageRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
      continue
    }
    // 组装路由
    var route = {
      path: '',
      component: null,
      name: '',
      meta: {
        ...window.SITE_CONFIG['contentTabDefault'],
        menuId: menuList[i].id,
        title: menuList[i].name,
      },
    }
    // eslint-disable-next-line
    let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) =>
      eval(s2)
    ) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      route['path'] = route['name'] = `i-${menuList[i].id}`
      route['meta']['iframeURL'] = URL
    } else {
      URL = URL.replace(/^\//, '').replace(/_/g, '-')
      if(!URL.startsWith('@')){
        route['path'] = route['name'] = URL.replace(/\//g, '-')
        route['component'] = () => import(`@/views/modules/${URL}`)
      }else if(URL.startsWith('@')){
        URL =URL.replace('@','/')
        route['path'] = route['name']=URL
      }
    }
    routes.push(route)
  }
  if (temp.length >= 1) {
    return fnAddDynamicMenuRoutes(temp, routes)
  }
  for (let i = routes.length - 1; i >= 0; i--) {
    let r = routes[i]

    if (!r.path.startsWith('/')) {
      r.path = '/' + r.path
    }
    let ex = moduleRoutes.children.find((c) => c.path === r.path)
    if (ex) {
      if (ex.path === '/home') {
        let tmpHome = {
          ...ex,
          ...r,
        }
        routes[i] = tmpHome
      } else {
        routes.splice(i, 1)
      }
    }
  }
  let tmp = {
    ...moduleRoutes,
    name: 'main-dynamic-menu',
    children: moduleRoutes.children.concat(routes),
  }
  // 添加路由
  router.addRoute(tmp)
  let tmp2 = { path: '*', redirect: { name: '404' } }
  router.addRoute(tmp2)
  // ,
  //   { path: '*', redirect: { name: '404' } }
  window.SITE_CONFIG['dynamicMenuRoutes'] = routes
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
}

export default router
